import { EXCLUDED_FILES_FOR_AI } from './indexedDbFileStorage';

/**
 * Checks if a file should be sent to the AI based on its extension and filename.
 * Returns true for source code and config files, false for binary/asset files.
 */
export function isCodeFile(filePath) {
    // Extract filename and extension
    const fileName = filePath.split('/').pop();
    const ext = fileName.split('.').pop().toLowerCase();

    // Check if file is in the excluded list (imported from indexedDbFileStorage)
    if (EXCLUDED_FILES_FOR_AI.includes(fileName)) {
        return false;
    }

    // Binary/Asset files to EXCLUDE (never send to AI)
    const binaryExtensions = [
        // Images
        'png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'ico', 'webp', 'avif',
        // Fonts
        'woff', 'woff2', 'ttf', 'otf', 'eot',
        // Videos/Audio
        'mp4', 'mov', 'avi', 'mkv', 'webm', 'mp3', 'wav', 'ogg', 'flac',
        // Archives
        'zip', 'tar', 'gz', 'rar', '7z', 'bz2',
        // Binaries
        'exe', 'dll', 'so', 'dylib', 'bin', 'dmg', 'pkg',
        // Documents
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'
    ];

    if (binaryExtensions.includes(ext)) {
        return false;
    }

    // Source code and config files to INCLUDE
    const codeExtensions = [
        // JavaScript/TypeScript
        'js', 'jsx', 'ts', 'tsx', 'mjs', 'cjs',
        // Web
        'html', 'css', 'scss', 'sass', 'less',
        // Python
        'py', 'pyw', 'pyx', 'pyi',
        // Java/Kotlin/Scala
        'java', 'kt', 'kts', 'scala',
        // C/C++
        'c', 'cpp', 'cc', 'cxx', 'h', 'hpp', 'hxx',
        // Other languages
        'go', 'rs', 'rb', 'php', 'swift', 'cs', 'sh', 'bash', 'zsh',
        // Config files
        'json', 'yaml', 'yml', 'toml', 'xml', 'ini', 'conf', 'config',
        // Documentation
        'md', 'mdx', 'txt', 'rst',
        // Build/Project files
        'gradle', 'maven', 'cmake', 'make', 'dockerfile'
    ];

    return codeExtensions.includes(ext);
}
